export default __webpack_public_path__ + "pdf/what-now-csv-guide_b421b14eaf6ccb653fe372b80d334dda.pdf";